<script setup lang="ts">

defineOptions({
  name: 'Example2'
});

// 硬币的正反  0为字面，1为图面
const coin1 = ref(0);

let timer;
const animationBox = ref();
const handleTransform = () => {
  // 防止1.5秒内重复点击
  if (timer) return;
  animationBox.value.classList.add('pic-box-animation');
  timer = setTimeout(() => {
    // 设置三个硬币的正反面
    coin1.value = coin1.value === 0 ? 1 : 0;
    animationBox.value.classList.remove('pic-box-animation');
    timer = null;

  }, 1500);

};

</script>

<template>
  <div class="pic-box" ref="animationBox">
    <div class="boxes" @click="handleTransform">
      <div class="box">
<!--        <img :class="coin1 ? 'img-pic' : 'img-text'" :src="coinPic" alt="">-->
<!--        <img :class="coin1 ? 'img-text' : 'img-pic'" :src="coinText" alt="">-->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pic-box {
  width: 100%;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;

  .boxes {
    width: 190px;
    height: 190px;
    background: #00acc1;
  }

  .box {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    border-radius: 50%;

    .img-pic {
      width: 156px;
      height: 156px;
      position: absolute;
      top: 17px;
      left: 17px;
      z-index: 1;
      background: #23c100;
    }

    .img-text {
      width: 156px;
      height: 156px;
      position: absolute;
      top: 17px;
      left: 17px;
      z-index: 0;
      background: #23c100;
    }
  }
}

.pic-box-animation {
  .box {
    animation: box-animation .2s linear 0s infinite;

    .img-pic {
      animation: img-pic-animation .2s linear 0s infinite;
    }

    .img-text {
      animation: img-text-animation .2s linear 0s infinite;
    }
  }


  @keyframes box-animation {
    0% {
      transform: rotateX(0deg)
    }
    50% {
      transform: rotateX(180deg)
    }
    100% {
      transform: rotateX(360deg)
    }
  }

  @keyframes img-pic-animation {
    0% {
      z-index: 1;
    }
    50% {
      z-index: 0;
    }
    100% {
      z-index: 1;
    }
  }

  @keyframes img-text-animation {
    0% {
      z-index: 0;
    }
    50% {
      z-index: 1;
    }
    100% {
      z-index: 0;
    }
  }
}
</style>